export default "/50f517735fec46580f19aae3e56e9fe21614ea75/20e765fe22790b7f1075e229233d4cab.svg";